module.exports = {
  COMPLIANCE_CHECK_STATUS: {
    PENDING: 'PENDING',
    PASS: 'PASS',
    FAIL: 'FAIL'
  },
  EVENT_STATUS: {
    NEW: 'NEW',
    PROCESSED: 'PROCESSED',
    SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP'
  },
  COMPLIANCE_TYPE_CODE: {
    ID_VERIFICATION: 'ID_VERIFICATION',
    WLC: 'WLC',
    CFC: 'CFC',
    BUSINESS_VERIFICATION: 'BUSINESS_VERIFICATION'
  }
};
